var tips = [{
    name: "招牌推荐",
    tag: "hot"
}, {
    name: "热门",
    tag: "hot"
}, {
    name: "鱼类",
    tag: "hot"
}, {
    name: "涮肉",
    tag: ""
}, {
    name: "汤",
    tag: ""
}, {
    name: "蔬菜",
    tag: ""
}, {
    name: "饮品",
    tag: ""
}, {
    name: "主食",
    tag: ""
}, {
    name: "米饭",
    tag: ""
}];

export default tips;


/** WEBPACK FOOTER **
 ** ./src/data/tips.js
 **/